import { Injectable } from '@angular/core';
import { CATBundle } from '../../../models/cat-bundle.model';

@Injectable({
  providedIn: 'root'
})
export class IosService {

  constructor() { }

  getCatBundle() {
    return this.handleIOSBridge();
  }

  private handleIOSBridge(): Promise<CATBundle> {
    return new Promise<CATBundle>((resolve, reject) => {
      const iosHandler = (e: any): void => {
        document.removeEventListener('PacificDidReceiveNativeCallback', iosHandler);

        const CATBundleIOS = e['detail']['parameters'];

        const CATBundleExist = !!CATBundleIOS && !!CATBundleIOS.cat1_token;
        if (CATBundleExist) {
          resolve(CATBundleIOS);
        } else {
          this.handleError('[iOS Service] CATBundle not found');
          reject('CATBundle not found');
        }
      }

      document.addEventListener('PacificDidReceiveNativeCallback', iosHandler);

      try {
        const tokenRequest = { action: 'getTokens', callback: 1.0 };
        window['webkit']['messageHandlers']['pacific'].postMessage(tokenRequest);
      } catch (error) {
        this.handleError('[iOS Service] Error getting CATBundle');
        reject('Error getting CATBundle');
      }
    });
  }
  private handleError(message: string) {
    console.error(message);
  }
}